'use strict';

var app = require('angular').module('app');
app.directive('clickOff', require('./clickOff'));
app.directive('runWhenPassedTop', require('./runWhenPassedTop'));
app.directive('anchorSmoothScroll', require('./anchorSmoothScroll'));
app.directive('setClassWhenAtTop', require('./setClassWhenAtTop'));
